import { ICAreaApi } from "./icarea.api";
import { ICAreaTypeApi } from "./icareatype.api";
import { ICMetaDescriptionApi } from "./icmetadescription.api";

import { IApi } from "../shared/iapi";
import { ICSchedulation } from "../entities/icschedulation";

export class ICSchedulationApi
  extends ICSchedulation
  implements IApi<ICSchedulation>
{
  AreaApi: ICAreaApi;
  AreaTypeApi: ICAreaTypeApi;
  MetaDescriptionApi: ICMetaDescriptionApi;
  MonitorId: number;
  NucId: number;
  AreaTree: string;
  NucDisplayName: string;

  constructor(data?: Partial<ICSchedulationApi>) {
    super(data);
    Object.assign(this, data);
  }
}
